import { IPublishOptionSchema } from '../../internalTypes';
import { getOptionId } from '../getOptionId';

export function getSelectedPeriodId(periods: IPublishOptionSchema[]): string | null {
  const paidPeriod = periods.find(({ isPaid }) => isPaid);
  const defaultPeriod = periods.find(({ isDefault }) => isDefault);
  const firstPeriod = periods[0];

  if (paidPeriod) {
    return getOptionId(paidPeriod);
  }

  if (defaultPeriod) {
    return getOptionId(defaultPeriod);
  }

  if (firstPeriod) {
    return getOptionId(firstPeriod);
  }

  return null;
}
